module.exports = __webpack_public_path__ + "static/catalyst-0819c47b678df4dd3790a4e78bf73608.svg";